const spanishTranslation = {
  Breadcrumb_Cycles: 'Ciclos',
  Breadcrumb_Contents: 'Contenidos',
  Breadcrumb_Home: 'Inicio',
  Breadcrumb_Role: 'Rol',
  Breadcrumb_Actions: 'Acciones',
  Breadcrumb_List: 'Lista',
  Breadcrumb_Tag: 'Etiquetas',
  Breadcrumb_Program: 'Programas',
  Breadcrumb_Contacts: 'Contactos',
  Breadcrumb_Locations: 'Ubicaciones',
  Breadcrumb_Roles: 'Roles',
  Breadcrumb_Users: 'Usuarios',
  Breadcrumb_EditCycle: 'Editar ciclo',
  Breadcrumb_Calender: 'Calendario',
  Breadcrumb_SharedFiles: 'Archivos compartidos',

  Btn_Save: 'Guardar',
  Btn_Start: 'Iniciar',
  Btn_ReOpen: 'Reabrir',
  Btn_Comment: 'Comentar',
  Btn_Create: 'Crear',
  Btn_Continue: 'Continuar',
  Btn_AddLocation: 'Agregar ubicación',
  Btn_Export: 'Exportar',
  Btn_SaveFilter: 'Guardar filtro',
  Btn_SavedFilter: 'Filtro guardado',
  Btn_AuditHistory: 'Historial de auditoría',
  Btn_ShowFilter: 'Mostrar filtro',
  Btn_HideFilter: 'Ocultar filtro',
  Btn_Delete: 'Eliminar',
  Btn_More: 'Más',
  Btn_Less: 'Menos',
  Btn_Apply: 'Aplicar',
  Btn_ClearFilters: 'Limpiar filtros',
  Btn_ManageDisplay: 'Administrar visualización',
  Btn_Logout: 'Cerrar sesión',
  Btn_Add: 'Agregar',
  Btn_Cancel: 'Cancelar',
  Btn_Yes: 'Sí',
  Btn_No: 'No',
  Title_ConfirmDelete: 'Confirmar eliminación',
  Msg_ConfirmDeleteAttachment: '¿Estás seguro de que deseas eliminar este archivo adjunto?',
  Btn_Upload: 'Subir',
  Btn_Submit: 'Enviar',
  Btn_Update: 'Actualizar',
  Btn_MakeFilesShareable: 'Hacer archivos compartibles',
  Btn_AddNew: 'Agregar nuevo',
  Btn_StateGraph: 'Gráfico de estado',
  Btn_Close: 'Cerrar',
  Btn_EditNa: 'Editar lista NA',
  Btn_NewAction: 'Nueva acción',
  Btn_NewEvent: 'Nuevo evento',
  Btn_Action: 'Acción',
  Btn_GenerateReport: 'Generar informe',
  Btn_ShowMoreComments: 'Más',
  Btn_Load5MoreLastCompletedActions: 'Cargar 5 acciones completadas más recientes',
  Btn_EditEnrollment: 'Editar lista de inscripción',
  Btn_Audit: 'Auditar',
  Btn_Audit2: 'Auditoría2',
  Btn_UploadThenProcess: 'Subir y luego procesar',
  Btn_ProcessExisting: 'Procesar existentes',
  Btn_AddMethods: 'Agregar método(s)',
  Btn_CopyMethods: 'Copiar método(s)',
  Btn_ManageFilters: 'Administrar filtros',
  Btn_Recheck: 'Volver a verificar',
  Btn_Caveats: 'Advertencias',
  Btn_Copy: 'Copiar',
  Btn_Profile: 'Perfil',
  Btn_Validate: 'Validar',
  Btn_Enrollment: 'Inscripción',
  Btn_ChangeMyPassword: 'Cambiar mi contraseña',
  Btn_NAList: 'Lista NA',
  Btn_Contact: 'Contacto',
  Btn_PrintPDF: 'Imprimir PDF',
  Btn_DownloadExcel: 'Descargar Excel',
  Btn_FinalizeAndEmail: 'Finalizar y enviar correo',
  Btn_Finalize: 'Finalizar',
  Btn_Refinalize: 'Refinalizar',
  Btn_Broadcast: 'Transmitir',
  Btn_SaveAsTemplate: 'Guardar como plantilla',
  Btn_Reset: 'Restablecer',
  Btn_AddActions: 'Agregar acción',
  Btn_Replicate: 'Replicar',
  Btn_Retry: 'Reintentar',
  Btn_Edit: 'Editar',
  Btn_Complete: 'Completar',
  Btn_Search: 'Buscar',

  Column_Action: 'Acción',
  Column_Filename: 'Nombre de archivo',
  Column_CreatedBy: 'Creado por',
  Column_CreatedByName: 'Creado por',
  Column_CreatedOn: 'Creado el',
  Column_LastUpdatedOn: 'Actualizado el',
  Column_LastUpdatedBy: 'Actualizado por',
  Column_LastUpdatedByName: 'Actualizado por',
  Column_AccreditationBody: 'Organismo de acreditación',
  Column_ExpirationDate: 'Fecha de vencimiento',
  Column_AuditDate: 'Fecha de auditoría',
  Column_NoofMajorNC: 'N.º de NC mayores',
  Column_NoofMinorNC: 'N.º de NC menores',
  Column_NoOfRecommendations: 'N.º de recomendaciones',
  Column_FileName: 'Nombre del archivo',
  Column_UploadedOn: 'Subido el',
  Column_UploadedBy: 'Subido por',
  Column_UpdatedOn: 'Actualizado el',
  Column_UpdatedBy: 'Actualizado por',
  Column_Type: 'Tipo',
  Column_Name: 'Nombre',
  Column_Comments: 'Comentarios',
  Column_ContentID: 'ID de contenido',
  Column_ListID: 'ID de lista',
  Column_ListName: 'Nombre de la lista',
  Column_Active: 'Activo',
  Column_RoleName: 'Nombre del rol',
  Column_Description: 'Descripción',
  Column_Role: 'Rol',
  Column_CountryName: 'Nombre del país',
  Column_RegionName: 'Nombre de la región',
  Column_UserID: 'ID de usuario',
  Column_FirstName: 'Nombre',
  Column_LastName: 'Apellido',
  Column_DocumentName: 'Nombre del documento',
  Column_ContentType: 'Tipo de contenido',
  Column_ContentCategory: 'Categoría de contenido',
  ContentCategoryListEntryName: 'Categoría de contenido',
  ContentTypeListEntryName: 'Tipo de contenido',
  ContentLanguageListEntryName: 'Idioma del contenido',
  Ascending: 'Ascendente',
  Descending: 'Descendente',
  ContentID: 'ID de contenido',
  Column_Title: 'Título',
  Column_ActionType: 'Tipo de acción',
  Column_AssignedTo: 'Asignado a',
  Column_Status: 'Estado',
  Column_DueDate: 'Fecha de vencimiento',
  Column_CompletedOn: 'Completado el',
  Column_ListEntryID: 'ID de entrada de lista',
  Column_StoreValue: 'Valor almacenado',
  Column_DisplayValue: 'Valor mostrado',
  Column_SourceSystemNames: 'Sistemas de origen',

  Error_MaxLengthIs100: 'La longitud máxima es 100',
  Error_MaxLengthIs10: 'La longitud máxima es 10',
  Error_SourceSystemIsRequired: 'El sistema de origen es obligatorio',
  Error_RoleIsRequired: 'El rol es obligatorio',
  Error_Message_SomethingWentWrong: '¡Algo salió mal!',
  Error_CannotDeleteAttachmentLinkedToAnotherContent: 'No se puede eliminar el archivo adjunto porque está vinculado a otro contenido.',
  FilesUsed_WithOther_Content: 'No se puede desmarcar el archivo adjunto porque está vinculado a otro contenido.',
  Error_OnlyOneAttachmentAllowedWhenContentTypeIsDocument: 'Solo se permite un archivo adjunto cuando el tipo de contenido es Documento',
  Error_LocationNameIsRequired: 'El nombre de la ubicación es obligatorio',
  Error_LocationTypeIsRequired: 'El tipo de ubicación es obligatorio',
  Error_CountryIsRequired: 'El país es obligatorio',
  Error_RegionIsRequired: 'La región es obligatoria',
  Error_RoleNameIsRequired: 'El nombre del rol es obligatorio',
  Error_DescriptionIsRequired: 'La descripción es obligatoria',
  Error_LevelIsRequired: 'El nivel es obligatorio',
  Error_RegionCodeIsRequired: 'El código de región es obligatorio',
  Error_MaxLengthIs5: 'La longitud máxima es 5',
  Error_ProgramNameRequired: 'El nombre del programa es obligatorio',
  Error_ProgramProductsRequired: 'Los productos del programa son obligatorios',
  Error_OrganizationRequired: 'La organización es obligatoria',
  Error_BusinessLineRequired: 'La línea de negocio es obligatoria',
  Error_LoadingDataError: 'Error al cargar los datos',
  Error_NoItemsFound: '¡No se encontraron elementos!',
  Error_NoUploadedFileFound: 'No se encontró ningún archivo cargado',
  Error_DueDateRequired: 'La fecha de vencimiento es obligatoria',
  Error_DateTimeFormatRequired: 'El formato de fecha y hora es obligatorio',
  Error_DateFormatRequired: 'El formato de fecha es obligatorio',
  Error_ProcessDateRequired: 'La fecha de proceso es obligatoria',
  Error_CycleNameIsRequired: 'El nombre del ciclo es obligatorio',
  Error_ProgramIsRequired: 'El programa es obligatorio',
  Error_MethodNameIsRequired: 'El nombre del método es obligatorio',
  Error_LocationAbbreviationIsRequired: 'La abreviatura de la ubicación es obligatoria',
  Error_MaxLengthIs3: 'La longitud máxima es 3',
  Error_MaxLength: 'La longitud máxima es {{length}}',
  Error_OnlyUpperCaseLettersAllowed: 'Solo se permiten letras mayúsculas',
  Error_NameIsRequired: 'El nombre es obligatorio',
  Error_NoPresetFound: '¡No se encontró ningún ajuste preestablecido!',
  Error_Message_ChangePasswordError: 'Error al cambiar la contraseña',
  Error_FirstNameIsRequired: 'El nombre es obligatorio',
  Error_LastNameIsRequired: 'El apellido es obligatorio',
  Error_EmailIsRequired: 'El correo electrónico es obligatorio',
  Error_DateFormatIsRequired: 'El formato de fecha es obligatorio',
  Error_DateTimeFormatIsRequired: 'El formato de fecha y hora es obligatorio',
  Error_MaxLengthIs50: 'La longitud máxima es 50',
  Error_AccreditationBodyRequired: 'El organismo de acreditación es obligatorio',
  Error_ExpirationDateRequired: 'La fecha de vencimiento es obligatoria',
  Error_UploadDocumentFirst: 'Primero sube el documento',
  Error_ReasonIsRequired: 'El motivo es obligatorio',
  Error_ActionTypeRequired: 'El tipo de acción es obligatorio',
  Error_TitleRequired: 'El título es obligatorio',
  Error_StatusNameRequired: 'El nombre del estado es obligatorio',
  Error_AssignedToRequired: 'La asignación es obligatoria',
  Error_TitleIsRequired: 'El título es obligatorio',
  Error_ContentGroupIsRequired: 'El grupo de contenido es obligatorio',
  Error_ContentTypeIsRequired: 'El tipo de contenido es obligatorio',
  Error_TagIsRequired: 'La etiqueta es obligatoria',
  Error_TestItemAlreadyExists: 'El/los elemento(s) de prueba [{{items}}] ya existen en el programa',
  Error_UnableToLogout: 'No se puede cerrar sesión.',
  Error_ColumnUpdateFailed: '¡Falló la actualización de la visualización de columnas!',
  Error_UnableToResetPassword: 'No se puede restablecer la contraseña.',
  Error_DashboardConfigurationCouldNotBeSaved: 'No se pudo guardar la configuración del panel.',
  Error_DashboardConfigurationCouldNotBeReset: 'No se pudo restablecer la configuración del panel.',
  Error_DashboardDefaultCannotBeRetrieved: 'No se puede recuperar el panel predeterminado.',
  Error_CategoryIsRequired: 'La categoría es obligatoria',
  Error_LinkIsRequired: 'El enlace es obligatorio',
  Error_InvalidUrl: 'Ingresa una URL válida',
  Error_ContentLanguageRequired: 'El idioma del contenido es obligatorio',
  Error_FileSizeExceeds: 'El tamaño del archivo no debe exceder 5 MB',
  Error_LogoFileSizeError: 'El tamaño del archivo no debe exceder 512 KB',

  Header_General: 'General',
  Header_Actions: 'Acciones',
  Header_MyActions: 'Mis acciones',
  Header_Action_Column_New: 'Pendiente',
  Header_Action_Column_Started: 'En progreso',
  Header_Action_Column_Completed: 'Completado',
  Header_ProgramInfo: 'Información del programa',
  Header_AddLocation: 'Agregar ubicación',
  Header_EditLocation: 'Editar ubicación',
  Header_AddRole: 'Agregar rol',
  Header_EditRole: 'Editar rol',
  Header_List: 'Lista',
  Header_Tag: 'Etiquetas',
  Header_ProgramSearch: 'Programas',
  Header_AddProgram: 'Agregar programa',
  Header_EditProgram: 'Editar programa',
  Header_Action: 'Acciones',
  Header_Region: 'Región',
  Header_AuditForCycle: 'Auditoría para - {{cycleName}}',
  Header_AddEditAccreditation: '{{op}} acreditaciones - {{location}}',
  Header_Role: 'Roles',
  Header_User: 'Usuarios',
  Header_UserCreate: 'Crear usuario',
  Header_RoleAndAccess: 'Rol y acceso',
  Header_AddContent: 'Agregar contenido',
  Header_EditContent: 'Editar contenido',
  Header_ContentsSearch: 'Contenidos',
  Header_Locations: 'Ubicaciones',
  Header_Profile: 'Perfil',
  Header_EditUser: 'Editar usuario',
  Header_Accreditations: 'Acreditaciones',
  Header_WelcomeToDashboard: 'Bienvenido a la página de inicio del Centro de Conocimiento.',
  Header_Calender: 'Calendario',
  Header_Dashboard: 'Panel',
  Header_SharedFiles: 'Archivos compartidos',

  Label_SortBy: 'Ordenar por',
  Label_Direction: 'Dirección',
  Label_Ascending: 'Ascendente',
  Label_Descending: 'Descendente',
  Label_Edit: 'Editar',
  Label_Accreditation: 'Acreditación',
  Label_Organization: 'Organización',
  Label_ProgramName: 'Programa',
  Label_CreatedBy: 'Creado por',
  Label_CreatedOn: 'Creado el',
  Label_ProgramProducts: 'Productos',
  Label_ProgramComments: 'Comentarios del programa',
  Label_Name: 'Nombre',
  Label_RoleName: 'Nombre del rol',
  Label_CategoryGroup: 'Grupo de categoría',
  Label_Category: 'Categoría de contenido',
  Label_SourceSystem: 'Sistema de origen',
  Label_ContentName: 'Nombre del contenido',
  Label_RoleInfo: 'Información del rol',
  Label_UserInfo: 'Información del usuario',
  Label_Access: 'Información de acceso',
  Label_Active: 'Activo',
  Label_Title: 'Título',
  Label_Link: 'Enlace',
  Label_Zone: 'Zona',
  Label_ActionStatus: 'Estado de la acción',
  Label_ActionType: 'Tipo de acción',
  Label_StatusName: 'Nombre del estado',
  Label_AssignedTo: 'Asignado a',
  Label_CreatedOnFrom: 'Creado desde',
  Label_CreatedOnTo: 'Creado hasta',
  Label_DueDateFrom: 'Fecha de vencimiento desde',
  Label_DueDateTo: 'Fecha de vencimiento hasta',
  Label_Roles: 'Roles',
  Label_Description: 'Descripción',
  Label_User: 'Usuario',
  Label_LocationName: 'Nombre de la ubicación',
  Label_LocationType: 'Tipo de ubicación',
  Label_ContentGroup: 'Grupo de contenido',
  Label_UserType: 'Tipo de usuario',
  Label_LocationAlias: 'Alias de ubicación',
  Label_Alias: 'Alias',
  Label_Region: 'Región',
  Label_Regions: 'Regiones',
  Label_Tenant: 'Inquilino',
  Label_State: 'Estado',
  Label_City: 'Ciudad',
  Label_PostCode: 'Código postal',
  Label_AddressLine2: 'Línea de dirección 2',
  Label_AddressLine1: 'Línea de dirección 1',
  Label_LocationAbbreviation: 'Abreviatura de ubicación',
  Label_Abbreviation: 'Abreviatura',
  Label_Timezone: 'Zona horaria',
  Label_FirstName: 'Nombre',
  Label_LastName: 'Apellido',
  Label_ListName: 'Nombre de la lista',
  Label_TagName: 'Nombre de la etiqueta',
  Label_Filters: 'Filtros',
  Label_Method: 'Método',
  Label_TestItem: 'Parámetro',
  Label_AutoImport: 'Importación automática',
  Label_FreqYr: 'Frecuencia/año',
  Label_SearchMethod: 'Buscar método',
  Label_No_Records_Found: '¡No se encontraron registros!',
  Label_Attachments: 'Archivos adjuntos',
  Label_AttachmentSharedCannotBeDeleted: 'Nota: los archivos adjuntos compartidos con otros contenidos no se pueden eliminar.',
  Label_Uploaded: 'Cargado',
  Label_Shared: 'Compartido',
  Label_SharedWithOtherContents: 'Compartido con otros contenidos',
  Label_SourceSystemCannotBeRemoved: 'No se pueden eliminar los sistemas de origen porque están en uso, pero se pueden agregar nuevos',

  Label_Parameter: 'Parámetro',
  Label_TestMethod: 'Método',
  Label_Unit: 'Unidad',
  Label_Products: 'Productos',
  Label_TestItems: 'Parámetros',
  Label_LocationInfo: 'Información de ubicación',
  Label_ContentInfo: 'Información del contenido',
  Label_ContentHistory: 'Historial de contenido',
  Label_ContentLanguage: 'Idioma del contenido',
  Label_VersionHistory: 'Historial de versiones',
  Label_General: 'General',
  Label_Address: 'Dirección',
  Label_BusinessLines: 'Líneas de negocio',
  Label_Product: 'Producto',
  Label_Email: 'Correo electrónico',
  Label_DateFormat: 'Formato de fecha',
  Label_DateTimeFormat: 'Formato de fecha y hora',
  Label_Level: 'Nivel',
  Label_Default: 'Predeterminado',
  Label_Type: 'Tipo',
  Label_Role: 'Rol',
  Label_NewPassword: 'Nueva contraseña',
  Label_ConfirmNewPassword: 'Confirmar nueva contraseña',
  Label_Phone: 'Teléfono',
  Label_Countries: 'Países',
  Label_Locations: 'Ubicaciones',
  Label_AddTag: 'Agregar etiqueta',
  Label_NND: 'NND',
  Label_Resolution: 'Resolución',
  Label_TestItemsForMethod: 'Parámetros para {{ methodName }}',
  Label_Scope: 'Alcance',
  Label_ListEntry: 'Entrada de lista',
  Label_TagEntries: 'Entradas de etiqueta',
  Label_TagEntry: 'Entrada de etiqueta',
  Label_NA: 'NA',
  Label_Location: 'Ubicación',
  Label_Country: 'País',
  Label_BusinessLine: 'Línea de negocio',
  Label_Program: 'Programa',
  Label_Comments: 'Comentarios',
  Label_Comment: 'Comentario',
  Label_Tags: 'Etiquetas',
  Label_AppliedMethodsAndTest: 'Método aplicado y parámetros',

  Label_Attachment: 'Archivo adjunto',
  Label_Selected: 'Seleccionado',
  Label_Methods: 'Métodos',
  Label_EditList: 'Editar lista',
  Label_EditTag: 'Editar etiquetas',
  Label_ListEntries: 'Entradas de lista',
  Label_ViewMore: 'Ver más',
  Label_ViewLess: 'Ver menos',
  Label_UpdateNAList: 'Actualizar lista NA',
  Label_AccreditationLogoText: 'Texto del logotipo de acreditación',
  Label_CertificateHyperlink: 'Hipervínculo del certificado',
  Label_ScopeHyperlink: 'Hipervínculo del alcance',
  Label_Latitude: 'Latitud',
  Label_Longitude: 'Longitud',
  Label_MainContact: 'Contacto principal',
  Label_SavingProgramMethods: 'Guardando métodos del programa',
  Label_Reason: 'Motivo',
  Label_HiUser: '¡Hola {{username}}!',
  Label_AssignedXActions: 'Hay <0>{{n}}</0> nuevas acciones asignadas para ti.',
  Label_XAnnouncemnets: 'Hay <0>{{n}}</0> nuevos anuncios enviados para ti.',
  Label_Search: 'Buscar',
  Label_RetriedBy: 'Reintentado el {{retryOn}} por {{retryBy}}',
  Label_Stretch: 'Expandido',
  Label_Compact: 'Compacto',
  Label_MethodBase: 'Base del método',
  Label_ParameterBase: 'Base del parámetro',
  Label_CalculationStrategy: 'Estrategia de cálculo',
  Label_ContentTypeListEntryName: 'Tipo de contenido',
  Label_ContentCategoryListEntryName: 'Categoría de contenido',
  Label_ContentType: 'Tipo de contenido',
  Label_VisibleFor: 'Visible para',
  Label_ActionTitle: 'Título de la acción',
  Label_DueDate: 'Fecha de vencimiento',
  Label_ContentID: 'ID de contenido',
  Label_Action: 'Acción',
  Label_Monthly: 'Mensual',
  Label_Weekly: 'Semanal',
  Label_ListID: 'ID de lista',
  Label_LinkUrl: 'URL del enlace',
  Label_LastUpdatedOn: 'Actualizado el',
  Label_LastUpdatedBy: 'Actualizado por',
  Label_RoleNames: 'Nombres de rol',
  Label_CountryName: 'Nombre del país',
  Label_RegionName: 'Nombre de la región',
  Label_UserID: 'ID de usuario',
  Label_Tag: 'Etiqueta',
  Label_OtherTags: 'Ingresa otras etiquetas',
  Label_AddOtherTags: 'Agregar otras etiquetas',
  Label_EnterOtherTags: 'Ingresa otras etiquetas',
  Label_Functionality: 'Funcionalidad',
  Label_Custom_Functionality: 'Funcionalidad personalizada',
  Label_ContentLanguageListEntryName: 'Idioma del contenido',
  Label_DocumentName: 'Nombre del documento',
  Label_UpdatedBy: 'Actualizado por',
  Label_UpdatedOn: 'Actualizado el',
  Label_SourceSystemNames: 'Sistema de origen',
  Label_CreatedByName: 'Creado por',
  Label_ActionTypeName: 'Tipo de acción',
  Label_OwnerName: 'Nombre del propietario',
  Label_CompletedOn: 'Completado el',

  Placeholder_SelectSourceSystem: 'Selecciona un sistema de origen',
  Placeholder_ContentLanguage: 'Idioma del contenido',

  Message_NoComments: 'Sin comentarios',
  Message_NoItems: '¡No hay elementos!',
  Confirm_Message_UnsavedProgram: '¿Deseas cerrar la ventana sin guardar el programa?',

  Nav_Menu_Program: 'Programa',
  Nav_Menu_Contents: 'Contenidos',
  Nav_Menu_Capability: 'Capacidad',
  Nav_Menu_MyActions: 'Mis acciones',
  Nav_Menu_Actions: 'Acciones',
  Nav_Menu_Calender: 'Calendario',
  Nav_Menu_Dashboard: 'Panel',
  Nav_Menu_Home: 'Inicio',
  Nav_Menu_Tags: 'Etiquetas',
  Nav_Menu_MasterData: 'Datos maestros',
  Nav_Menu_List: 'Lista',
  Nav_Menu_Administrator: 'Administración',
  Nav_Menu_Roles: 'Roles',
  Nav_Menu_Users: 'Usuarios',
  Nav_Menu_SharedFiles: 'Archivos compartidos',

  Placeholder_Selectanoption: 'Selecciona una opción',
  PlaceHolder_Comments: 'Comentarios',
  Tab_Title_AppName: 'CTD KC',
  Tab_Profile: 'Perfil',
  Tab_Announcement: 'Anuncio',
  Tab_Notification: 'Notificación',

  Table_NoUserfound: '¡No se encontró ningún usuario!',

  Text_AddContent: 'Agregar contenido',
  Text_EditContent: 'Editar contenido',
  Text_AddLocation: 'Agregar ubicación',
  Text_EditLocation: 'Editar ubicación',
  Text_EditRole: 'Editar rol',
  Text_AddRole: 'Agregar rol',
  Text_True: 'Verdadero',
  Text_False: 'Falso',
  Title_NewTag: 'Nueva etiqueta',

  Title_Showing_X_Records: 'Mostrando {{length}} registro(s)',
  Title_NewList: 'Nueva lista',
  Title_DataExport: 'Exportación de datos',

  Toast_CreatedSuccessfully: 'Creado correctamente',
  Toast_UpdatedSuccessfully: 'Actualizado correctamente',
  Toast_ColumnUpdatedSuccessfully: 'La visualización de columnas se actualizó correctamente',
  Toast_ActionStatusUpdatedSuccessfully: 'El estado de la acción se actualizó correctamente',
  Toast_UpdateFailed: 'Error al actualizar',
  Toast_ColumnUpdateFailed: 'Error al actualizar la visualización de columnas',
  Toast_FilterDisplayUpdatedSuccessfully: '¡La visualización del filtro se actualizó correctamente!',
  Toast_FilterDisplayUpdateFailed: '¡Error al actualizar la visualización del filtro!',
  Toast_UnableToSaveFilter: '¡No se pudo guardar el filtro preestablecido!',
  Toast_SavedSuccessfully: '¡Guardado correctamente!',
  Toast_FilesUploadedSuccessfully: 'Archivo(s) subido(s) correctamente',
  Toast_FileDownloadedSuccessfully: '¡Archivo descargado correctamente!',
  Toast_FileDeletedSuccessfully: 'Archivo(s) eliminado(s) correctamente',
  Toast_MethodAndParameterAlreadyExists: 'El método y parámetro seleccionados ya existen en el programa',
  Toast_AcknowledgedSuccessfully: 'Reconocido correctamente',
  Toast_ProfileUpdatedSuccessfully: 'Perfil actualizado correctamente',
  Toast_NoteAddedSuccessfully: 'Nota agregada correctamente',
  Toast_ProgramUpdatedSuccessfully: 'Programa actualizado correctamente',
  Toast_ProgramCreatedSuccessfully: 'Programa creado correctamente',
  Toast_DashboardConfigurationSavedSuccessfully: 'Configuración del panel guardada correctamente',
  Toast_DashboardConfigurationResettedSuccessfully: 'Configuración del panel restablecida correctamente',
  Info_Message_AllowedFormats: ' Formatos permitidos: .docx, .xlsx, .pdf, .pptx',

  Tooltip_ContentsSearch: 'KC | Búsqueda de contenidos',
  Tooltip_List: 'KC | Lista',
  Tooltip_Tags: 'KC | Etiquetas',
  Tooltip_Role: 'KC | Roles',
  Tooltip_User: 'KC | Usuarios',
  Tooltip_Download: 'Descargar',
  Tooltip_Default: 'Predeterminado',
  Tooltip_ActionSearch: 'KC | Búsqueda de acciones',
  Tooltip_AddLocation: 'KC | Agregar ubicación',
  Tooltip_EditLocation: 'KC | Editar ubicación',
  Tooltip_Export_To_CSV: 'Exportar a CSV',
  Tooltip_Locations: 'KC | Ubicaciones',
  Tooltip_AddContent: 'KC | Agregar contenido',
  Tooltip_EditContent: 'KC | Editar contenido',
  Tooltip_Favorite: 'Favorito',
  Tooltip_Unfavorite: 'Quitar de favoritos',
  Tooltip_EditLayout: 'Editar diseño',
  Tooltip_Calendar: 'Calendario',
  Tooltip_ReadAndUnderstand: 'Leer y entender',
  Tooltip_MethodEquivalence: 'Equivalencia de método',
  Tooltip_CompanySummaryReport: 'KC | Informe resumido de la empresa',
  Tooltip_DataExport: 'KC | Exportación de datos',
  Tooltip_ReportGrading: 'KC | Clasificación de informe',
  Tooltip_LabSummaryReport: 'KC | Informe de ubicación',
  Tooltip_AndersonDarling: 'Anderson Darling',
  Tooltip_EditUser: 'KC | Editar usuario',
  Tooltip_SharedFiles: 'KC | Archivos compartidos',

  ShareDialog_Title: 'Hacer que los archivos sean compartibles',
  ShareDialog_Description: 'Configura aquí los ajustes de uso compartido de tus archivos.',
  ShareDialog_DefaultShareNote: 'Nota: todos los archivos cargados se comparten de forma predeterminada con el sistema de origen que los cargó. Puedes compartirlos con otros sistemas de origen eligiéndolos en los desplegables.',
  ShareDialog_SelectOptions: 'Selecciona opciones',
  ShareDialog_ShareSystems: 'Compartir con otros sistemas de origen',
  ShareDialog_ValidationError: 'Debe seleccionarse al menos 1 elemento',

  Label_ChooseFromSharedFiles: 'Elegir de los archivos compartidos existentes',
  Label_SearchSharedFiles: 'Buscar archivos compartidos',
  Placeholder_TypeDocumentName: 'Escribe el nombre del documento...',

  ErrorBoundary_Title: '¡Ups! Algo salió mal',
  ErrorBoundary_Message: 'Lamentamos las molestias. Intenta actualizar la página.',
  ErrorBoundary_Details: 'Detalles del error (solo desarrollo)',
  ErrorBoundary_GoHome: 'Ir a Contenidos',
};
export default spanishTranslation;
